<template>
  <div class="">
    <Card back>
      <template slot="header">
        <h5 class="d-inline">ارسال صورتــــحساب</h5>
        <hr />
      </template>
      <template slot="content">
        <ChackupTaxSale @StateMojavez="StateMojavez"></ChackupTaxSale>
        <div class="container" :id="$route.name" v-if="MojavezPage">
          <div class="row">
            <div class="mb-3">
              <a v-if="Add == 0" class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="Add = 1" title=" افزودن تنظیمات ">
                <h4><i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i></h4>
              </a>
              <a v-if="Add != 0" class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="Add = 0" title="لغو افزودن">
                <h4><i class="fas fa-times text-danger"></i></h4>
              </a>
            </div>
            <div class="col-12" v-if="Add != 0">
              <div class="row">
                <div class="col-12 mb-3">
                  <h5>برای ارسال صورت حساب خود یکی از روش های زیر را رانتخاب کنید.</h5>
                  <hr />
                </div>

                <div class="col-12" v-if="FileType == 0 || FileType == 1">
                  <div class="Uploader Pointer" @click="OpenUploader(1)">
                    <h5 class="text-warning">بارگذاری فایل Excel</h5>
                    <i class="fad fa-file-import fa-5x text-logo mt-3"></i>
                    <span v-if="FileName == null">فایل خود را بارگذاری کنید</span>
                    <div class="mt-5" v-else>
                      فایل <span class="text-warning" style="word-break: break-word"> {{ FileName }} </span> بارگذاری شده
                    </div>
                    <span class="text-warning" v-if="FileName == null">( کلیک کنید )</span>
                    <span class="text-logo" v-else>( برای بارگزاری دوباره ، کلیک کنید )</span>
                  </div>
                  <button class="btn btn-warning mt-2" v-if="FileName != null" @click="RemoveFile"><i class="fad fa-trash px-2"></i> حذف فایل</button>
                  <input type="file" class="form-control d-none" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" id="File" @change="UploadFile($event, 1)" />
                  <hr />
                </div>
                <div class="col-12">
                  <h5 class="text-warning">اتصال مستقیم به پایگاه داده</h5>
                  <div class="row">
                    <div class="col-md-3 col-12">
                      <small>آدرس سرور پایگاه داده</small>
                      <input type="text" class="form-control text-left" v-model="DBServer[0]" dir="ltr" />
                    </div>
                    <div class="col-md-3 col-12">
                      <small> نام پایگاه داده</small>
                      <input type="text" autocomplete="new-password" v-model="DBServer[1]" class="form-control text-left" dir="ltr" />
                    </div>
                    <div class="col-md-3 col-12">
                      <small> نام کاربری پایگاه داده</small>
                      <input type="text" autocomplete="new-password" v-model="DBServer[2]" class="form-control text-left" dir="ltr" />
                    </div>
                    <div class="col-md-3 col-12">
                      <small>رمز ورود پایگاه داده</small>
                      <input type="password" autocomplete="new-password" v-model="DBServer[3]" class="form-control text-left" dir="ltr" />
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-md-9 col-12"></div>
                    <div class="col-md-3 col-12">
                      <button @click="CheckDB" class="btn btn-success w-100">بررسی اتصال پایگاه داده</button>
                    </div>
                  </div>
                  <hr />
                </div>
                <div class="col-12" v-if="FileType == 0 || FileType == 2">
                  <div class="Uploader Pointer" @click="OpenUploader(2)">
                    <h5 class="text-warning">بارگذاری فایل JSON</h5>
                    <i class="fad fa-file-import fa-5x text-logo mt-3"></i>
                    <span v-if="FileName == null">فایل خود را بارگذاری کنید</span>
                    <div class="mt-5 px-2" v-else>
                      فایل <span class="text-warning" style="word-break: break-word"> {{ FileName }} </span> بارگذاری شده
                    </div>

                    <small class="text-warning" v-if="FileName == null">( کلیک کنید )</small>
                    <small class="text-logo" v-else>( برای بارگزاری دوباره ، کلیک کنید )</small>
                  </div>
                  <button class="btn btn-warning mt-2" v-if="FileName != null" @click="RemoveFile"><i class="fad fa-trash px-2"></i> حذف فایل</button>
                  <input type="file" class="form-control d-none" id="FileJson" @change="UploadFile($event, 2)" accept=".json" />
                  <hr />
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12 text-center"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid" v-if="Add == 0">
          <div class="row" v-if="MojavezPage">
            <div class="col-12 text-center">
              <h5 class="text-warning">اطلاعات زیر را با اطلاعات وارد شده در فایل مطابقت دهید و درصورتی که مورد تایید شما می باشد بر روی دکـــمـــه ادامه و ارسال صورتحساب کلیک کنید</h5>
            </div>
            <!-- Header Info -->
            <div class="col-12 text-center">
              <div class="font-weight-bold"><h6 class="mt-2 text-logo">اطلاعات هدر صورت حساب</h6></div>
            </div>
            <div class="col-12">
              <BnpGrid :key="Render" :hasRowNum="true" :propsColumn="ColumnHeader" :propsRows="RowsHeader" :action="false" :NoSearch="true" :NoPagination="ShowPageNationHeader">
                <template slot="inty" slot-scope="props">
                  <span class="">{{ props.props.inty == 1 ? 'نوع اول' : props.props.inty == 2 ? 'نوع دوم' : props.props.inty == 3 ? 'نوع سوم' : 'نا مشخص' }}</span>
                </template>
                <template slot="inp" slot-scope="props">
                  <span class="">{{
                    props.props.inp == 1 ? 'فروش' : props.props.inp == 2 ? 'فروش ارزی' : props.props.inp == 3 ? 'صورتحساب طلا و جواهر و پلاتین' : props.props.inp == 4 ? 'قرارداد پیمانکاری' : props.props.inp == 5 ? 'قبوض خدماتی' : props.props.inp == 6 ? 'بلیت هواپیما' : 'نامشخص'
                  }}</span>
                </template>
              </BnpGrid>
            </div>
            <!-- Body Info -->
            <div class="col-12 text-center">
              <div class="font-weight-bold"><h6 class="mt-2 text-logo">اطلاعات بدنه صورت حساب</h6></div>
            </div>
            <div class="col-12">
              <BnpGrid :key="Render" :hasRowNum="true" :propsColumn="ColumnBody" :propsRows="RowsBody" :action="false" :NoSearch="true" :NoPagination="ShowPageNationBody"> </BnpGrid>
            </div>
            <!-- payments Info -->
            <div class="col-12 text-center" v-if="Rowspayments.length && Rowspayments.length > 0">
              <div class="font-weight-bold"><h6 class="mt-2 text-logo">اطلاعات پرداخت صورت حساب</h6></div>
            </div>
            <div class="col-12" v-if="Rowspayments.length && Rowspayments.length > 0">
              <BnpGrid :key="Render" :hasRowNum="true" :propsColumn="Columnpayments" :propsRows="Rowspayments" :action="false" :NoSearch="true" :NoPagination="ShowPageNationpayments"> </BnpGrid>
            </div>
            <!-- payments Info -->
            <div class="col-12 text-center" v-if="Rowspayments.length && Rowspayments.length > 0">
              <div class="font-weight-bold"><h6 class="mt-2 text-logo">اطلاعات پرداخت صورت حساب</h6></div>
            </div>
            <div class="col-12" v-if="Rowsextension.length && Rowsextension.length > 0">
              <BnpGrid :key="Render" :hasRowNum="true" :propsColumn="Columnextension" :propsRows="Rowsextension" :action="false" :NoSearch="true" :NoPagination="ShowPageNationextension"> </BnpGrid>
            </div>

            <div class="col-12 mt-3" v-if="RowsHeader.length > 0">
              <button class="btn btn-success" @click="SendInvoice()"><i class="fad fa-check mx-3"></i> ادامه و ارسال صورتحساب</button>
            </div>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import ChackupTaxSale from '../ChackupTaxSale.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import moment from 'moment-jalaali'
export default {
  data() {
    return {
      DBServer: ['', '', '', ''],
      FileName: null,
      FileType: 0,
      MojavezPage: false,
      Add: 0,
      JsonFile: null,
      Render: 0,

      ShowPageNationHeader: true,
      ShowPageNationBody: true,
      ShowPageNationpayments: true,
      ShowPageNationextension: true,

      RowsHeader: [],
      RowsBody: [],
      Rowspayments: [],
      Rowsextension: [],

      ColumnHeader: [
        {
          name: 'taxid',
          label: 'شماره منحصر بفرد مالیاتی',
          visibility: true,
        },
        {
          name: 'indatim',
          label: 'تاریخ و زمان صدور میلادی',
          visibility: true,
        },
        {
          name: 'indati2m',
          label: 'تاریخ و زمان ایجاد صورتحساب - میلادی',
          visibility: true,
        },
        {
          name: 'inty',
          label: 'نوع صورتحساب',
          visibility: true,
        },
        {
          name: 'inno',
          label: 'سریال صورتحساب داخلی حافظه مالیاتی',
          visibility: true,
        },
        {
          name: 'irtaxid',
          label: 'شماره منحصر بفرد صورتحساب مالیاتی مرجع',
          visibility: true,
        },
        {
          name: 'inp',
          label: 'الگوی صورتحساب',
          visibility: true,
        },
        {
          name: 'ins',
          label: 'موضوع صورتحساب',
          visibility: true,
        },
        {
          name:'tins' ,
          label:'شناسه ملی فروشنده' ,
          visibility: true,
        },
        {
          name: 'tob',
          label: 'نوع شخص خریدار',
          visibility: true,
        },
        {
          name: 'bid',
          label: 'شماره/شناسه ملی/شناسه مشارکت مدنی/کد فراگیر',
          visibility: true,
        },
        {
          name: 'tinb',
          label: 'شماره اقتصادی خریدار',
          visibility: true,
        },
        {
          name: 'sbc',
          label: 'کد شعبه فروشنده',
          visibility: true,
        },
        {
          name: 'bpc',
          label: 'کد پستی خریدار',
          visibility: true,
        },
        {
          name: 'bbc',
          label: 'کد شعبه خریدار',
          visibility: true,
        },
        {
          name: 'bbc',
          label: 'نوع پرواز',
          visibility: true,
        },
        {
          name: 'bpn',
          label: 'شماره گذرنامه خریدار',
          visibility: true,
        },
        {
          name: 'scln',
          label: 'شماره پروانه گمرکی',
          visibility: true,
        },
        {
          name: 'scc',
          label: 'کد گمرک محل اظهار فروشنده',
          visibility: true,
        },
        {
          name: 'cdcn',
          label: 'شماره کوتاژ اظهار نامه گمرکی',
          visibility: true,
        },
        {
          name: 'cdcd',
          label: 'تاریخ کوتاژ اظهارنامه گمرکی',
          visibility: true,
        },
        {
          name: 'crn',
          label: 'شناسه یکتای ثبت قرارداد فرونشده',
          visibility: true,
        },
        {
          name: 'billid',
          label: 'شماره اشتراک/شناسه قبض بهره بردار',
          visibility: true,
        },
        {
          name: 'tprdis',
          label: 'مجموع مبلغ قبل از کسر تخفیف',
          visibility: true,
        },
        {
          name: 'tdis',
          label: 'مجموع تخفیفات',
          visibility: true,
        },
        {
          name: 'tadis',
          label: 'مجموع مبلغ پس از کسر تخفیفات',
          visibility: true,
        },
        {
          name: 'tvam',
          label: 'مجموع مالیات بر ارزش افزوده',
          visibility: true,
        },
        {
          name: 'todam',
          label: 'مجموع سایر مالیات ، عوارض و وجوه قانونی',
          visibility: true,
        },
        {
          name: 'tbill',
          label: 'مجموع صورتحساب',
          visibility: true,
        },
        {
          name: 'tonw',
          label: 'مجموع وزن خالص',
          visibility: true,
        },
        {
          name: 'torv',
          label: 'مجموع ارزش ریالی',
          visibility: true,
        },
        {
          name: 'tocv',
          label: 'مجموع ارزش ارزی',
          visibility: true,
        },
        {
          name: 'setm',
          label: 'روش تسویه',
          visibility: true,
        },
        {
          name: 'cap',
          label: 'مبلغ پرداختی نقدی',
          visibility: true,
        },
        {
          name: 'insp',
          label: 'مبلغ نسیه',
          visibility: true,
        },
        {
          name: 'tvop',
          label: 'مجموع سهم مالیات بر ارزش افزوده از پرداخت',
          visibility: true,
        },
        {
          name: 'tax17',
          label: 'مالیات موضوع ماده 17',
          visibility: true,
        },
      ],
      ColumnBody: [
        {
          name: 'sstid',
          label: 'شناسه کالا / خدمت',
          visibility: true,
        },
        {
          name: 'sstt',
          label: 'شرح کالا/خدمت',
          visibility: true,
        },
        {
          name: 'am',
          label: 'تعداد/مقدار',
          visibility: true,
        },
        {
          name: 'mu',
          label: 'واحد اندازه گیری',
          visibility: true,
        },
        {
          name: 'nw',
          label: 'وزن خالص',
          visibility: true,
        },
        {
          name: 'fee',
          label: 'میلغ واحد',
          visibility: true,
        },
        {
          name: 'cfee',
          label: 'میزن ارز',
          visibility: true,
        },
        {
          name: 'cut',
          label: 'نوع ارز',
          visibility: true,
        },
        {
          name: 'exr',
          label: 'نرخ برابری ارز با ریال',
          visibility: true,
        },
        {
          name: 'ssrv',
          label: 'ارزش ریالی کال',
          visibility: true,
        },
        {
          name: 'sscv',
          label: 'ارزش ارزی کالا',
          visibility: true,
        },
        {
          name: 'prdis',
          label: 'مبلغ قبل از تخفیف',
          visibility: true,
        },
        {
          name: 'dis',
          label: 'مبلغ تخفیف',
          visibility: true,
        },
        {
          name: 'adis',
          label: 'مبلغ بعد از تخفیف',
          visibility: true,
        },
        {
          name: 'vra',
          label: 'نرخ مالیات بر ارزش افزوده',
          visibility: true,
        },
        {
          name: 'vam',
          label: 'مبلغ مالیات بر ارزش افزوده',
          visibility: true,
        },
        {
          name: 'odt',
          label: 'موضوع سایر مالیات و عوارض',
          visibility: true,
        },
        {
          name: 'odr',
          label: 'نرخ سایر مالیات و عوارض',
          visibility: true,
        },
        {
          name: 'odam',
          label: 'مبلغ سایر مالیات و عوارض',
          visibility: true,
        },
        {
          name: 'olt',
          label: 'موضوع سایر وجود قانونی',
          visibility: true,
        },
        {
          name: 'olr',
          label: 'نرخ سایر وجود قانونی',
          visibility: true,
        },
        {
          name: 'olam',
          label: 'مبلغ سایر وجود قانونی',
          visibility: true,
        },
        {
          name: 'consfee',
          label: 'اجرت ساخت',
          visibility: true,
        },
        {
          name: 'spro',
          label: 'سود فروض',
          visibility: true,
        },
        {
          name: 'bros',
          label: 'حق العمل',
          visibility: true,
        },
        {
          name: 'tcpbs',
          label: 'جمع کل اجرت ، حق العمل  و سود',
          visibility: true,
        },
        {
          name: 'cop',
          label: 'سهم نقدی از پرداخت',
          visibility: true,
        },
        {
          name: 'vop',
          label: 'سهم مالیات بر ارزش افزوده از پرداخت',
          visibility: true,
        },
        {
          name: 'bsrn',
          label: 'شناسه یکتای ثبت حق العمل کاری',
          visibility: true,
        },
        {
          name: 'tsstam',
          label: 'مبلغ کل کالا / خدمات',
          visibility: true,
        },
      ],
      Columnpayments: [
        {
          name: 'iinn',
          label: 'شماره سویچ پرداخت',
          visibility: true,
        },
        {
          name: 'acn',
          label: 'شماره پذیرنده فروشگاهی',
          visibility: true,
        },
        {
          name: 'trmn',
          label: 'شماره پایانه',
          visibility: true,
        },
        {
          name: 'pmt',
          label: 'روش پرداخت',
          visibility: true,
        },
        {
          name: 'trn',
          label: 'شماره پیگیری',
          visibility: true,
        },
        {
          name: 'pcn',
          label: 'شماره کارت پرداخت کننده صورتحساب',
          visibility: true,
        },
        {
          name: 'pid',
          label: 'شماره/شناسه ملی/کد فراگیر اتباع غیر ایرانی پرداخت کننده صورتحساب',
          visibility: true,
        },
        {
          name: 'pdt',
          label: 'تاریخ و زمان تراکنش',
          visibility: true,
        },
        {
          name: 'pv',
          label: 'مبلغ پرداختی',
          visibility: true,
        },
      ],
      Columnextension: [
        {
          name: 'key',
          label: 'فیلد',
          visibility: true,
        },
        {
          name: 'value',
          label: 'مقدار',
          visibility: true,
        },
      ],
    }
  },
  components: { Card, ChackupTaxSale, BnpGrid },
  methods: {
    StateMojavez(val) {
      this.MojavezPage = val
      // this.getData();
    },
    UploadFile(e, Type) {
      // Type 1= ExcelFile, Type 2=JsonFile
      this.FileType = Type
      this.FileName = e.srcElement.files[0].name
      var SendData = { Action: '', Method: 'POST', ArryfildValue: null, Token: this.$session.get('Token') }
      if (Type == 1) {
        SendData.Action = 'Tax/ConvertToJsonAsResult'
      }
      if (Type == 2) {
        SendData.Action = 'Tax/jsonToInvoice'
      }
      var formData = new FormData()
      formData.append('File', e.srcElement.files[0])
      SendData.ArryfildValue = formData
      this.$PostFormData(SendData)
        .then((result) => {
          // console.log(result);
          if (result.Body || result.body) {
            this.$toasted.success('اطلاعات فایل شما با موفقیت خوانده شد', { duration: 2000 })
          }

          this.JsonFile = result
          if (Type == 1) {
            this.RowsHeader = this.JsonFile.Header
            this.JsonFile.Header.length > 10 ? (this.ShowPageNationHeader = false) : (this.ShowPageNationHeader = true)
            this.RowsBody = this.JsonFile.Body
            this.JsonFile.Body.length > 10 ? (this.ShowPageNationBody = false) : (this.ShowPagenationBody = true)
            this.Rowspayments = this.JsonFile.payments
            this.JsonFile.payments.length > 10 ? (this.ShowPageNationpayments = false) : (this.ShowPageNationpayments = true)
            this.Rowsextension = this.JsonFile.extension
            this.JsonFile.extension.length > 10 ? (this.ShowPageNationextension = false) : (this.ShowPageNationextension = true)
          }
          if (Type == 2) {
            this.RowsHeader = []
            this.RowsHeader.push(this.JsonFile.header)
            this.JsonFile.header.length > 10 ? (this.ShowPageNationHeader = false) : (this.ShowPageNationHeader = true)
            this.RowsBody = this.JsonFile.body
            this.JsonFile.body.length > 10 ? (this.ShowPageNationBody = false) : (this.ShowPagenationBody = true)
            this.Rowspayments = this.JsonFile.payments
            this.JsonFile.payments.length > 10 ? (this.ShowPageNationpayments = false) : (this.ShowPageNationpayments = true)
            this.Rowsextension = this.JsonFile.extension
            this.JsonFile.extension.length > 10 ? (this.ShowPageNationextension = false) : (this.ShowPageNationextension = true)
          }
          this.Add = 0
          this.Render++
        })
        .catch(() => {
          this.$toasted.error('خطا در بارگیری فایل ', { duration: 2000 })
          this.$toasted.error('به نظر میرسه که فایل شما دارای مشکل فنی و ساختاری می باشد ، لطفا ساختار فایل خود را با فایل مرجع بررسی نمایید', { duration: 7000 })
          this.RemoveFile()
        })
    },
    OpenUploader(Type) {
      // Type 1= ExcelFile, Type 2=JsonFile
      if (Type == 1) {
        document.getElementById('File').click()
      }
      if (Type == 2) {
        document.getElementById('FileJson').click()
      }
    },
    RemoveFile() {
      this.FileType = 0
      this.FileName = null
      this.JsonFile = null
      this.RowsHeader = []
      this.RowsBody = []
      this.Rowspayments = []
      this.Rowsextension = []
    },
    SendInvoice() {
      try {
        var cid =  this.$session.get('CustomerInfo').Id 
        var SendData = { Action: '', Method: 'POST', ArryfildValue: null, Token: this.$session.get('Token') }
        // تبدیل تاریخ شمسی به unixtime برای فایل های اکسل
        if (this.FileType == 1) {
          var indatim = moment(this.RowsHeader[0].indatim + '10:10:10', 'jYYYY/jM/jD HH:mm:ss.SSS').format('YYYY-M-D HH:mm:ss.SSS')
          console.log("😎 ~ SendInvoice ~ indatim:", indatim)
          var indatim2 = moment(this.RowsHeader[0].indati2m + '10:10:10', 'jYYYY/jM/jD HH:mm:ss.SSS').format('YYYY-M-D HH:mm:ss.SSS')

          this.RowsHeader[0].indatim = Math.floor(new Date(indatim).getTime() )
          this.RowsHeader[0].indati2m = Math.floor(new Date(indatim2).getTime() )
        }

        // SendData.ArryfildValue = { header: this.RowsHeader[0], body: this.RowsBody, payments: this.Rowspayments, extension: this.Rowsextension, customerInfo: cid[0] }
        SendData.ArryfildValue = { header: this.RowsHeader[0], body: this.RowsBody, payments: this.Rowspayments, extension: this.Rowsextension }
        SendData.Action = 'Tax/NewInvoice/?id='+cid
        console.log(SendData.ArryfildValue);
        this.$PostData(SendData).then((result) => {
          if (result.status == 'Failed') {
            this.$mySweetDefaultTost('خطا ', result.referenceNumber, 'error', 3000)
          } else {
            this.$toasted.success('صورتحساب با موفقیت ارسال شد ' + 'کد رهگیری : ' + result.referenceNumber, { duration: 4000 })
            // this.$router.push({name:"inqueryInvoice"})
          }
        })
      } catch (error) {}
    },
    CheckDB() {
      var DataAxios = { Action: 'Tax/CheckDataBase', Method: 'POST', ArryfildValue: { StringArray: this.DBServer } }
      this.$PostData(DataAxios).then((result) => {
        alert(result)
        if (result) {
          this.$cookies.set('DBTax', this.DBServer)
        }
      })
    },
  },
  mounted() {
    if (this.$cookies.get('DBTax')) {
      this.DBServer = this.$cookies.get('DBTax').split(',')
      // console.warn(this.$cookies.get('DBTax').split(','))
    }
  },
}
</script>
<style scoped>
hr {
  height: 2px;
  background-color: #333;
}
thead th,
td {
  font-weight: normal;
  white-space: nowrap !important;
}
/*.Uploader {
  width: 100%;
  border: 2px dashed var(--logo-color) !important;
  border-radius: 8px;
}
*/
.Uploader:hover .fa-file-import {
  color: #0c6ec9 !important;
  transition: 0.3s;
}
</style>
